import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { addCustomer, addUser, getstatesByGuid, getUser, saveCustomerAddress,getstates, userService, } from "../../services/AuthenticationService";
// import User from "../../utils/json/User";
import AssignedBranch from "../../utils/json/AssignedBranch";
import { UserBranchDetail } from "../../utils/json/UserBranchDetail";
import Branch from "../../utils/json/Branch";
import UserRole from "../../utils/json/UserRole";
import { CustomerClass } from "../../utils/json/Customer";
import { CustomerReceiptType } from "../../utils/json/CustomerReceiptType";
import { LedgerClass } from "../../utils/json/Ledger";
import { useSelector } from "react-redux";
import './Rgister.css';
import { FaEye, FaEyeSlash } from "react-icons/fa";

const RegisterPage = (data) => {
  const navigate = useNavigate();
  const { register, handleSubmit, watch, setValue, formState: { errors } } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const [formData, setFormData] = useState({});
  const [permanentAddress, setPermanentAddress] = useState("");
  const [deliveryAddress1, setDeliveryAddress1] = useState("");
  const [isSameAddress, setIsSameAddress] = useState(false);
  const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
     const [error, setError] = useState(null);
    // const isSameAddress = watch("isSameAddress");
  // const handleCheckboxChange = () => {
  //   setIsSameAddress(!isSameAddress);
  //   if (!isSameAddress) {
  //     setDeliveryAddress(permanentAddress); // Copy permanent address
  //   } else {
  //     setDeliveryAddress(""); // Clear if unchecked
  //   }
  // };

  

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
      deliveryAddress: name === "permanentAddress" && formData.isSameAddress ? value : formData.deliveryAddress,
    }));
  };
  const [showPassword, setShowPassword] = useState(false);
  

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

 // const { branch } = useSelector((state) => state.branchlist);
  const [states, setStates] = useState([]);
  //const { userId } = useSelector((state) => state.auth);
  const userId = useSelector((state) => state.auth.userId); 

  useEffect(() => {
    //resetmodal();
    fetchStates();
  }, [ data, setValue]);

    useEffect(() => {
          if (userId) {
            userService(userId)
              .then((response) => {
                setFormData(response);
              })
              .catch((error) => console.error("Error fetching profile:", error));
          }
        }, [userId]);
console.log("userId",userId)
  const fetchStates = async () => {
    try {
      const response = await getstates();
      setStates(response);
    } catch (error) {
      console.error("Error fetching states:", error?.response?.data?.Message);
    }
  };

  const handleFormSubmit = async (formData) => {
    const objCustomer = new CustomerClass();
    const objCustRecptTYpe = new CustomerReceiptType();
    const objLedger = new LedgerClass();
    const objBranch = new Branch(); // create branch object
  
    objCustomer.name = formData.name;
    objCustomer.fullName = "";
    objCustomer.mobile = formData.primaryContactNo;
    objCustomer.email = formData.email;
    objCustomer.address1 = formData.address1;
    objCustomer.address2 = "";
    objCustomer.address3 = "";
    objCustomer.discountPercentage = 0;
    objCustomer.city = "";
    objCustomer.pin = formData.pincode;
    objCustomer.phone = "";
    objCustomer.fax = "";
    objCustomer.landMark = "";
    objCustomer.gstNo = "";
    objCustomer.UserName = formData.userName;
    objCustomer.Password = formData.password;
    objCustomer.deliveryAddress = "";
    objCustomer.country = null;
    objCustomer.creditLimit = 0;
    objCustomer.guid = null;
    objCustomer.version = 0;
    objCustomer.isDeleted = false;
    objCustomer.state = await getstatesByGuid(formData.state);
    objCustomer.updatedUser = `{00000000-0000-0000-0000-000000000000}`;
    
    // Correcting state object
    // objCustomer.state = {
    //   name: formData.state,
    //   code: "", // you can keep code empty or fetch code if needed
    //   id: 0,
    //   guid: "",
    //   version: 0,
    //   isDeleted: false,
    //   createdUser: null,
    //   createdDate: "0001-01-01T00:00:00",
    //   updatedUser: null,
    //   updatedDate: "0001-01-01T00:00:00"
    // };
  
    // Customer Receipt Type
    objCustomer.customerReceiptType = {
      id: 0,
      guid: "",
      version: 0,
      isDeleted: false,
      createdUser: "",
      createdDate: new Date().toISOString(),
      updatedUser: "",
      updatedDate: new Date().toISOString(),
      name: "",
      Name: ""
    };
  
    // Ledger
    objCustomer.ledger = {
      id: 0,
      guid: "",
      version: 0,
      isDeleted: false,
      createdUser: "",
      createdDate: new Date().toISOString(),
      updatedUser: "",
      updatedDate: new Date().toISOString(),
      name: ""
    };
  
    // Branch
    objCustomer.branch = {
      name: "",
      company: null,
      prefixInvoice: null,
      address1: null,
      address2: null,
      address3: null,
      phone: null,
      email: null,
      cloneBranchId: null,
      id: 0,
      guid: "00000000-0000-0000-0000-000000000000",
      version: 0,
      isDeleted: false,
      createdUser: null,
      createdDate: "0001-01-01T00:00:00",
      updatedUser: null,
      updatedDate: "0001-01-01T00:00:00"
    };
  

    try {
      const response = await addCustomer(objCustomer);
  
      if (response) {
        toast.success("Registration successful");
        navigate("/login");
      } else if (response === false) {
        toast.error("Failed");
      }
    } catch (error) {
      toast.error(error?.response?.data?.Message || "Something went wrong");
      console.error("Error handling:", error?.response?.data?.Message);
    }
  };
  
 
  return (
    <>
      {/* <div className="container-xxl pt-5"> */}
        {/* <div className="signup-wrapper"> */}
          <div className="signup-wrapper">
            <div className="signup-image" data-wow-delay="0.1s">
              <img className="img-fluid m-0" src="/images/menu-1.jpg" alt="" />
             </div>
            <div className="signup-form" data-wow-delay="0.5s">
              <form action="/" className="contact-form" onSubmit={handleSubmit(handleFormSubmit)}>
                <div className="row">
                  <div className="heading-section" data-aos="fade-up">
                    <p className="subheading mb-4 text-center">Sign Up</p>
                  </div>
                  
                  <div className="col-md-6 ">
                    <div className="form-group">
                      <input type="text"
                      {...register("name", { required: "Full Name is required" })}
                        name="name"
                        className="form-control"
                       
                        onChange={handleChange}
                        placeholder="Name"
                        required />
                    </div>
                  </div>
                  
{/* phone number */}
                   <div className="col-md-6">
                    <div className="form-group">
                      <input type="phone"
                       {...register("primaryContactNo", { required: "Contact Number is required" })}
                        className="form-control"
                        name="primaryContactNo"
                        placeholder="Contact Number"
                     
                        onChange={handleChange}
                        required />
                    </div>
                  </div>

{/* email */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <input type="text"
                      {...register("email", { required: "Email is required" })}
                        className="form-control"
                        name="email"
                        placeholder="Email Id"
                       
                        onChange={handleChange}
                        required />
                    </div>
                  </div>
 {/* pincode */}
 <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        name="pincode"
                        placeholder="Pincode"
                        {...register("pincode", { required: "Pincode is required" })}
                        onChange={handleChange}
                        required
                      />

                    </div>
                  </div>

                </div>


                <div className="row">
                  {/* address */}
                  <div className="col-md-12">
                    <div className="form-group">
                      <textarea
                        name="address1"
                        id="" cols="30" rows="3"
                        className="form-control"
                        {...register("address1", { required: "Permanent Address is required" })}
                        placeholder="Permanent Address"
                        value={formData.address1}
                        onChange={handleChange}
                        //  disabled={formData.isSameAddress} 
                        required

                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  {/* address */}
                  {/* <div className="col-md-12">
                    <div className="form-group">
                      <textarea
                        name="address1"
                        id="" cols="30" rows="3"
                        className="form-control"
                        {...register("address2", { required: "Delivery Address is required" })}
                        placeholder="Delivery Address"
                        value={formData.address2}
                        onChange={handleChange}
                        //  disabled={formData.isSameAddress} 
                        required

                      />
                    </div>
                  </div> */}
                </div>


    

                <div className="row">
                 
                  {/* state */}
                  {/* <div className="col-lg-6">
                    <div className="form-group">

                      <input
                        type="text"
                        className="form-control"
                        name="state"
                        placeholder="State"
                        {...register("state", { required: "State is required" })}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div> */}
                  <div className="col-md-6 ">
                        <div className="form-group">
                          {/* <label>
                            State<span className="text-danger">*</span>
                          </label> */}
                          <select
                            {...register("state")}
                            defaultValue={data?.state?.guid || ""}
                            className=" form-control black-select"   onChange={handleChange}
                            required
                          >
                            <option value="" disabled>
                              Select State
                            </option>
                            {states?.map((state) => (
                              <option key={state.guid} value={state.guid}>
                                {state.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>


                 {/* country */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        name="country"
                        placeholder="Country"
                        {...register("country", { required: "Country is required" })} 
                        onChange={handleChange}
                        required
                      />

                    </div>
                  </div>
                   {/* username */}
                   <div className="col-md-6">
                    <div className="form-group">
                      <input type="text"
                      {...register("userName", { required: "Username is required" })}
                        name="userName"
                        className="form-control"
                        placeholder="UserName"
                       
                        onChange={handleChange}
                        required />
                    </div>
                  </div>
                  {/* password */}
                  <div className="col-md-6">
                    <div className="form-group">
                      <input type={showPassword? "text" :"password"}
                        className="form-control"
                        placeholder="Password"
                        name="password"
                        {...register("password", { required: "Password is required" })}
                        onChange={handleChange} required />
                             <span
                                            className="password-toggle-icon"
                                            onClick={togglePasswordVisibility}
                                            style={{
                                              position: "absolute",
                                              right: "15px",
                                              top: "50%",
                                              transform: "translateY(-50%)",
                                              cursor: "pointer",
                                              color: "#fff",
                                            }}
                                          >
                                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                                          </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 mt-3">
                <div className="form-group">
                <button type="submit"
                    value="REGISTER"
                    className="btn btn-primary" >
                      REGISTER
                      </button>
                </div>
                </div>
                <div className="col-md-12 text-center mt-3">
                <p> Already have an account ?
                  <span className="primary-color">
                    <Link className="nav-link" to="/login">Login</Link>
                  </span>
                </p>
              </div>

              </form>
           


            </div>
          </div>
        {/* </div> */}
      {/* </div> */}
      {products.map((item) => {
                  
                  return (
                      <div key={item.id} className="col-md-12">

                      </div>
                  )
                }
              )}

    </>
  );
};

export default RegisterPage;
